import { createStore } from "./store.ts";

export interface ConfirmOptions {
  title: string;
  message?: string;
  confirmLabel: string;
  cancelLabel?: string;
  /** "danger" styles the confirm button for irreversible actions. */
  tone?: "default" | "danger";
}

interface Pending extends ConfirmOptions {
  resolve: (ok: boolean) => void;
}

export const confirmStore = createStore<{ pending: Pending | null }>({ pending: null });

/** Ask the user to confirm; resolves true on confirm, false on cancel/Escape. */
export function confirmDialog(opts: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    confirmStore.get().pending?.resolve(false);
    confirmStore.set({ pending: { ...opts, resolve } });
  });
}
